import * as http from '../utils/http';

export default function (AdapterConstructor, settings) {
  if (!_.isFunction(AdapterConstructor)) {
    throw new Error('Adapter constructor should be a function');
  }

  if (!_.isUndefined(settings) && (!_.isObject(settings) || _.isNull(settings))) {
    throw new Error('Adapter settings should be an object');
  }

  return new AdapterConstructor(settings, http);
}



// WEBPACK FOOTER //
// ./src/transport/adapters/Adapter.js